import { render, staticRenderFns } from "./PersonaCard.vue?vue&type=template&id=7eb25773&"
import script from "./PersonaCard.vue?vue&type=script&lang=js&"
export * from "./PersonaCard.vue?vue&type=script&lang=js&"
import style0 from "./PersonaCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports